"use client";

import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { projectCountAtom } from "@/store/home";

function HomeStatProject(): ReactElement | null {
  const t = useTranslations("home.StatProject");
  const count = useAtomValue(projectCountAtom);

  if (!count) return null;

  return (
    <div className="p-0 flex flex-row gap-2">
      <span className="font-mono text-3xl text-pink-100">{count}</span>
      <span className="text-sm text-pink-300">
        {t("label", { count: count })}
      </span>
    </div>
  );
}

export { HomeStatProject };
